<template>
<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div v-if="cart && cart.length">
        <div class="card-title navigation">
          <router-link to="/loja">
            Loja
          </router-link>
          <i class="fa fa-angle-right"> </i>
          Resumo do pedido
        </div>
        <br />
        <div>
          <table class="table b-table b-table-stacked-lg">
            <thead>
              <tr>
                <th class="text-center"></th>
                <th>Oferta</th>
                <th class="th-description">Origem</th>
                <th class="th-description">Emissor da NF</th>
                <th class="text-center">Valor</th>
                <th class="text-center">Qtd</th>
                <th class="text-left">Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in cart" :key="index">
                <td>
                  <product-image :product="item.offer.product" :product_variation="item.offer.product_variation" />
                </td>
                <td>
                  <router-link :to="'/oferta/'+item.offer._id">
                    {{item.offer.product_variation.name}}
                  </router-link>
                  <small v-if="item.offer.supplier"><br />{{item.offer.supplier.name}}</small>
                  <!-- <small v-if="item.offer.organization"><br />{{item.offer.organization.name}}</small> -->
                </td>
                <td>
                  <small v-if="item.offer.address">{{item.offer.address.description}}</small>
                </td>
                <td>
                  <small>{{invoiceIssuer(item.offer.invoice_issuer)}}</small>
                </td>
                <td class="text-center">
                  {{item.offer.final_price | moeda}}
                </td>
                <td class="text-center">
                  {{item.qtd}}
                </td>
                <td>
                  {{item.offer.final_price * item.qtd | moeda}}
                </td>
                <td class="td-actions">
                  <button type="button" size="sm" rel="tooltip" data-placement="left" title="Remover do carrinho" class="btn" @click="removeFromCart(index)">
                    <i class="fa fa-close"></i>
                  </button>
                </td>
              </tr>
              <tr>
                <td colspan="5"></td>
                <td>
                  Total
                </td>
                <td colspan="1">
                  <strong>{{total | moeda}}</strong>
                </td>
                <td colspan="1"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <br>
        <div v-if="client && isClient">
          <h4 class="text-center">Finalize pedido</h4>
          <br>
          <div>
            <b-form-group label="Escolha um usuario em nome de quem será feita esse pedido" v-if="isLink || isA('seller')">
              <form-entity-select :items="clients" label="Selecione o usuário" :form="form" :input="saveAssignedClient" field="assignedClient" />
            </b-form-group>

            <b-form-group label="Selecione outras redes relacionadas a esse pedido" v-if="isLink">
              <form-entities-select type="organizations" label="Selecione o usuário" :form="form" field="relatedOrganizations" />
            </b-form-group>
          </div>
          <br>
          <h6 class="text-center">Confirme os dados abaixo para finalizar o pedido</h6>
          <br>
          <div class="row">
            <div class="col-sm-6">
              <b-form-group label="Nome *">
                <b-form-input v-model="form.name" v-validate="'required'" name="name" />
                <field-error :msg="veeErrors" field="name" />
              </b-form-group>
            </div>
            <div class="col-sm-6">
              <b-form-group label="CPF/CNPJ *">
                <b-form-input v-model="form.cnpj" v-validate="'required'" name="cnpj" v-mask="['###.###.###-##', '##.###.###/####-##']" />
                <field-error :msg="veeErrors" field="cnpj" />
              </b-form-group>
            </div>
            <div class="col-sm-6">
              <b-form-group label="Atividade principal">
                <b-form-input v-model="form.main_activity" name="main_activity" />
              </b-form-group>
            </div>
            <div class="col-sm-6">
              <b-form-group label="Inscrição estadual">
                <b-form-input v-model="form.state_registration" name="state_registration" />
              </b-form-group>
            </div>
            <div class="col-sm-6">
              <b-form-group label="Telefone *">
                <b-form-input v-model="form.phone" v-validate="'required'" name="phone" placeholder="(99) 99999-9999" v-mask="['(##) ####-####', '(##) #####-####']" />
                <field-error :msg="veeErrors" field="phone" />
              </b-form-group>
            </div>
            <div class="col-sm-6">
              <b-form-group label="Email *">
                <b-form-input v-model="form.email" v-validate="'email|required'" name="email" />
                <field-error :msg="veeErrors" field="email" />
                <div class="text-right" v-if="isEditing()">
                  <a class="pointer" @click="changePassword">Alterar senha</a>
                </div>
              </b-form-group>
            </div>
            <div class="col-sm-12">
              <b-form-group label="Endereço *">
                <span v-if="form.address" class="text-black">{{form.address.description}}</span>
                <location :cb="setAddress" :current_address="form.address" :autoload="false" />
              </b-form-group>
            </div>
          </div>
        </div>
        <br>
        <button :disabled="isLink && form.assignedClient == null" type="button" class="btn btn-success pull-right" @click="saveOrder">Finalizar pedido <i class="fa fa-arrow-right"></i></button>
        <router-link :to="'/loja'">
          <button type="button" class="btn btn-primary pull-right"><i class="fa fa-arrow-left"></i> Continuar comprando</button>&nbsp;&nbsp;
        </router-link>

        <!-- <a @click="clearCart" class="btn btn-warning pull-right">Limpar carrinho</a> -->
      </div>
      <div v-else class="text-center">
        <h4>Seu carrinho está vazio</h4>
        <router-link :to="'/loja'" class="btn btn-default">
          Voltar para a loja
        </router-link>
        <router-link :to="'/pedidos'" class="btn btn-default" if="isClient">
          Ver meus pedidos
        </router-link>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import Location from '@/components/Location'
import ProductImage from '@/components/ProductImage'
import FieldError from '@/components/FieldError'
import FormEntitySelect from '@/components/FormEntitySelect';
import FormEntitiesSelect from '@/components/FormEntitiesSelect';


export default {

  name: 'Cart',
  data() {
    var client = null
    client = this.$store.state.currentUser
    var form = {
      name: '',
      email: '',
      address: null,
      phone: '',
      main_activity: '',
      state_registration: '',
      cnpj: '',
      cart: [],
      assignedClient: null,
      relatedOrganizations: []
    }
    if (client) {
      this.setClient(client, form)
    }

    return {
      clients: [],
      client: client,
      form: form,
    }
  },
  computed: {
    cart() {
      return this.$store.state.cart
    },
    total() {
      return this.$store.state.cart.reduce(function(a, item) {
        return a + (Number(item.qtd) * Number(item.offer.final_price))
      }, 0);
    }
  },
  async created () {
    if (this.isLink || this.isA('seller')) {
      const clients = await axios.get('users', { params: { role: 'client' } })
      if (clients) {
        this.clients = clients.data.map(client => {
          client.title = client.name
          return client
        })
        .sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });
      }
    }
  },
  methods: {
    removeFromCart(index) {
      this.$store.dispatch('removeFromCart', index)
    },
    clearCart() {
      this.$store.dispatch('clearCart')
      this.notify("Carrinho limpo!")
      this.$router.replace('/loja')
    },
    saveAssignedClient(user) {
      this.form.assignedClient = user.id
      this.setClient(user, this.form)
    },
    setClient(client, form) {
      form.name = client.name
      form.cnpj = client.cnpj
      form.email = client.email
      form.address = client.address
      form.phone = client.phone
      form.main_activity = client.main_activity
      form.state_registration = client.state_registration
      form.supplier = client.supplier
      form.organization = client.organization
    },
    saveOrder() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true
          this.form.cart = this.cart
          axios({
            method: 'POST',
            url: 'shop/order',
            data: this.form
          }).then(resp => {
            var order = resp.data
            if (order && order._id) {
              this.notify("Seu pedido de compra foi realizado com o sucesso! Em breve entraremos em contato.")
              this.$store.dispatch('clearCart')
              this.$router.replace('/pedido/' + order._id)
            }
            this.isSending = false
          }).catch(() => {
            this.$router.replace('/entrar')
          })
        }
      })
    },
    setAddress(address) {
      this.form.address = address
    }

  },
  components: {
    ProductImage,
    FieldError,
    Location,
    FormEntitySelect,
    FormEntitiesSelect

  }
};
</script>
